import React from 'react';
import { styled } from '@compiled/react';
import type { MenuProps } from '@atlaskit/select';
import type { SelectOption } from '../../../../common/types.tsx';

const Menu = ({ innerRef, innerProps, children }: MenuProps<SelectOption, true>) => (
	// eslint-disable-next-line jira/integration/test-id-by-folder-structure
	<MenuBox data-testid="refinement-bar.common.ui.select.menu" ref={innerRef} {...innerProps}>
		{children}
	</MenuBox>
);
export default Menu;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const MenuBox = styled.div({
	display: 'flex',
	flexDirection: 'column',
	overflow: 'hidden',
});
